export { Amplify, LazyLoader as AmplifyLoader } from './amplify';

export { API } from './API';
export { Auth } from './Auth';
export { Storage } from './Storage';
